'use strict';

const $ = require('jquery');

class Lavalamp {

    constructor() {

        let $filterBlock = $('.filter-block');

        if ($filterBlock.length > 0) {

            require('./../../../../build/node_modules/@components/lavalamp/jquery.lavalamp.js');

            let $lavaItems = $filterBlock.find('[data-lavalamp-item]');
            let start = 0;

            $lavaItems.each(function (index) {

                start = index;

                if ($(this).hasClass('selected')) {

                    return false;
                }

            });

            let $lavalampHolder = $filterBlock.find('[data-lavalamp]');
            let target = $lavalampHolder.data('lavalamp');

            if ($lavalampHolder.length > 0) {

                $lavalampHolder.lavaLamp({
                    target: target,
                    startItem: start,
                    autoResize: true
                });

            }

        }

    }

}

module.exports = Lavalamp;
